import { Modal, Button, Card, Col, DatePicker, Divider, Form, Input, Layout, Radio, Row, Select, AutoComplete, Table, Tabs, Typography, Space, Spin, Checkbox, message, Tree } from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useState, useEffect } from "react";
import { Pie, Column, Line } from '@ant-design/plots';
import DataDetail from "../../../components/DataDetail";
import {
    getErrors, getLines, getMachineOfLine, getCustomers,
    getProducts, getStaffs, getLoSanXuat, getWarehouses, getCaSanXuats, getPQCHistory, getDataFilterUI, getDetailDataError, errorData,
    getTreeLines
} from '../../../api/ui/main';
import dayjs from "dayjs";
import { exportPQC, exportQCErorList, exportQCHistory, exportReportQC } from '../../../api/ui/export';
import { baseURL } from '../../../config';
import { LoadingOutlined } from "@ant-design/icons";


const { Sider } = Layout;
const { RangePicker } = DatePicker;

const QualityPQC = (props) => {
    document.title = "UI - PQC";
    const [listLines, setListLines] = useState([]);
    const [listMachines, setListMachines] = useState([]);
    const [listIdProducts, setListIdProducts] = useState([]);
    const [listLoSX, setListLoSX] = useState([]);
    const [listStaffs, setListStaffs] = useState([]);
    const [listCustomers, setListCustomers] = useState([]);
    const [listErrors, setListErrors] = useState([]);
    const [selectedLine, setSelectedLine] = useState();
    const [listNameProducts, setListNameProducts] = useState([]);
    const [totalPage, setTotalPage] = useState(1);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [params, setParams] = useState({
        page: 1,
        pageSize: 10,
        date: [dayjs(), dayjs()]
    });
    useEffect(() => {
        (async () => {
            const res1 = await getTreeLines();
            setListLines(res1.data);
            const res5 = await getCustomers();
            setListCustomers(res5.data.map(e => {
                return { ...e, label: e.name, value: e.id }
            }));
        })()
        // btn_click()
    }, [])

    useEffect(() => {
        (async () => {
            var res = await getDataFilterUI({ khach_hang: params.khach_hang });
            if (res.success) {
                setListNameProducts(res.data.product.map(e => {
                    return { ...e, label: e.name, value: e.id }
                }));
                setListLoSX(Object.values(res.data.lo_sx).map(e => {
                    return { label: e, value: e }
                }));
            }
        })()
    }, [params.khach_hang])

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };

    const [data, setData] = useState();
    const [dataTable2, setDataTable2] = useState();
    const [dataLineChart, setDataLineChart] = useState([]);
    const [dataPieChart, setDataPieChart] = useState([]);
    const [dataPieChart_NG, setDataPieChart_NG] = useState([]);

    const configLineChart = {
        animation: false,
        data: dataLineChart,
        height: 200,
        xField: 'date',
        yField: 'value',
        seriesField: 'error',
        legend: {
            position: 'top',
        },
        smooth: true,
        // animation: {
        //     appear: {
        //         animation: 'path-in',
        //         duration: 5000,
        //     },
        // },
    };
    const [dataPieChart1, setDataPieChart1] = useState([]);
    const configPieChart1 = {
        appendPadding: 10,
        height: 200,
        data: dataPieChart1,
        angleField: 'value',
        colorField: 'name',
        radius: 0.8,
        label: {
            type: 'outer',
            offset: '30%',
            content: '{name} {percentage}',
            style: {
                textAlign: 'center',
                textBaseline: 'alphabetic',
            },
        },
        legend: false
    };
    const [dataPieChart2, setDataPieChart2] = useState([]);
    const configPieChart2 = {
        appendPadding: 10,
        height: 200,
        data: dataPieChart2,
        angleField: 'value',
        colorField: 'name',
        radius: 0.8,
        label: {
            type: 'outer',
            offset: '30%',
            content: '{name} {percentage}',
            style: {
                textAlign: 'center',
                textBaseline: 'alphabetic',
            },
        },
        legend: false
    };
    const [dataColChart, setDataColChart] = useState([]);
    const configColChart1 = {
        animation: false,
        data: dataColChart,
        height: 200,
        xField: 'name',
        yField: 'value',
        label: {
            position: 'top',
            style: {
                fill: '#000000',
            },
            offset: '-30%',
            content: ({ value }) => `${value}%`,
        },
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: false,
            },
        },
        meta: {
            name: {
                alias: 'Tên lỗi',
            },
            value: {
                alias: 'Tỷ lệ',
                tickInterval: 5,
                formatter: (value) => `${value}%`,
            },
        },
    };
    const configColChart2 = {
        animation: false,
        data: dataColChart,
        height: 200,
        xField: 'name',
        yField: 'frequency',
        label: {
            position: 'top',
            style: {
                fill: '#00000',
            },
            offset: '-30%',
        },
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: false,
            },
        },
        meta: {
            name: {
                alias: 'Tên lỗi',
            },
            frequency: {
                tickInterval: 10,
                alias: 'Tần xuất',
            },
        },
    };
    const [dataPieChart3, setDataPieChart3] = useState([]);
    const configPieChart3 = {
        animation: false,
        appendPadding: 10,
        height: 200,
        data: dataPieChart3,
        angleField: 'value',
        colorField: 'name',
        radius: 0.8,
        label: {
            type: 'outer',
            offset: '30%',
            content: '{name} {percentage}',
            style: {
                textAlign: 'center',
                textBaseline: 'alphabetic',
            },
        },
        legend: false
    };
    const configPieDetailChart = {
        appendPadding: 10,
        height: 200,
        data: dataPieChart_NG,
        angleField: 'value',
        colorField: 'error',
        radius: 0.8,
        legend: false,
        label: {
            type: 'outer',
            content: '{name} {percentage}',
        },
    };

    async function btnNG_click(record) {
        const errors = record.errors;
        console.log(errors);
        if (!errors || errors.length <= 0) return;
        else {
            setDataPieChart_NG(Object.keys(errors).map((item, i) => {
                return {
                    error: errors[item].name,
                    value: errors[item].value,
                }
            }))
            setDataDetailError([...Object.keys(errors).map((item, i) => {
                return {
                    name: errors[item].name,
                    value: errors[item].value
                }
            })])
            showModal();
        }
    }
    const [messageApi, contextHolder] = message.useMessage();
    const onChangeChecbox = (e, record) => {
        if (e.target.checked) {
            setSelectedLot(record.lot_id);
        } else {
            setSelectedLot();
        }
    }

    const columns2 = [
        {
            title: 'STT',
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            render: (value, record, index) => ((page - 1) * pageSize) + index + 1,
            fixed: 'left'
        },
        {
            title: 'Ngày PQC kiểm tra',
            dataIndex: 'thoi_gian_kiem_tra',
            key: 'thoi_gian_kiem_tra',
            align: 'center',
            fixed: 'left'
        },
        {
            title: 'Ca',
            dataIndex: 'ca_sx',
            key: 'ca_sx',
            align: 'center',
        },
        {
            title: 'Xưởng',
            dataIndex: 'xuong',
            key: 'xuong',
            align: 'center',
        },
        {
            title: 'Công đoạn',
            dataIndex: 'cong_doan',
            key: 'cong_doan',
            align: 'center',
        },
        {
            title: 'Máy sản xuất',
            dataIndex: 'machine',
            key: 'machine',
            align: 'center',
        },
        {
            title: 'Mã máy',
            dataIndex: 'machine_id',
            key: 'machine_id',
            align: 'center',
        },
        {
            title: 'Khách hàng',
            dataIndex: 'khach_hang',
            key: 'khach_hang',
            align: 'center',
        },
        {
            title: 'Mã hàng',
            dataIndex: 'product_id',
            key: 'product_id',
            align: 'center',
        },
        {
            title: 'Tên sản phẩm',
            dataIndex: 'ten_san_pham',
            key: 'ten_san_pham',
            align: 'center',
        },
        {
            title: 'Lô SX',
            dataIndex: 'lo_sx',
            key: 'lo_sx',
            align: 'center',
        },
        {
            title: 'Mã thùng/pallet',
            dataIndex: 'lot_id',
            key: 'lot_id',
            align: 'center',
        },
        {
            title: 'Số lượng đầu ra thực tế',
            dataIndex: 'sl_dau_ra_hang_loat',
            key: 'sl_dau_ra_hang_loat',
            align: 'center',
        },
        {
            title: 'Số lượng đầu ra OK',
            dataIndex: 'sl_dau_ra_ok',
            key: 'sl_dau_ra_ok',
            align: 'center',
        },
        {
            title: 'Số lượng tem vàng',
            dataIndex: 'sl_tem_vang',
            key: 'sl_tem_vang',
            align: 'center',
        },
        {
            title: 'Số lượng NG (SX tự KT)',
            dataIndex: 'sl_ng_sxkt',
            key: 'sl_ng_sxkt',
            align: 'center',
        },
        {
            title: 'Công nhân SX',
            dataIndex: 'user_sxkt',
            key: 'user_sxkt',
            align: 'center',
        },
        {
            title: 'Số lượng NG (PQC)',
            dataIndex: 'sl_ng_pqc',
            key: 'sl_ng_pqc',
            align: 'center',
        },
        {
            title: 'PQC kiểm tra',
            dataIndex: 'user_pqc',
            key: 'user_pqc',
            align: 'center',
        },
        {
            title: 'Số lượng NG',
            dataIndex: 'sl_ng',
            key: 'sl_ng',
            align: 'center',
            render: (value1, record, index) => {
                value1 = parseInt(value1);
                //   let lot_id = record['lot_id'];
                return <>
                    <Button style={{ backgroundColor: 'red', color: 'white' }}
                        onClick={() => btnNG_click(record)}>
                        {value1}
                    </Button>

                </>
            }
        },
        {
            title: 'Tỉ lệ NG',
            dataIndex: 'ti_le_ng',
            key: 'ti_le_ng',
            align: 'center',
        },
    ];

    const [chartLoading, setChartLoading] = useState(false);
    const loadChartData = async (params) => {
        setChartLoading(true);
        var res = await errorData(params);
        var pieChart1 = [];
        Object.keys(res.data[0] ?? {}).map((key, index) => {
            if (index <= 4) {
                pieChart1.push(res.data[0][key]);
            }
        })
        setDataPieChart1(pieChart1);
        var pieChart2 = [];
        Object.keys(res.data[1] ?? {}).map((key, index) => {
            if (index <= 4) {
                pieChart2.push(res.data[1][key]);
            }
        })
        setDataColChart(pieChart2);
        var pieChart3 = [];
        Object.keys(res.data[2] ?? {}).map((key, index) => {
            if (index <= 4) {
                pieChart3.push(res.data[2][key]);
            }
        })
        setDataPieChart3(pieChart3);
        setDataLineChart(res.data[0])
        // console.log(pieChart1, pieChart2, pieChart3);
        setChartLoading(false);
    }
    const loadDataTable = async (params) => {
        setLoading(true)
        const res1 = await getPQCHistory(params);
        setTotalPage(res1.data.totalPage);
        setData(res1.data);
        setLoading(false);
    }
    function btn_click(page = 1, pageSize = 10) {
        setPage(page);
        setPageSize(pageSize);
        loadDataTable({ ...params, page, pageSize })
        loadChartData({ ...params, page, pageSize })
    }
    useEffect(() => {
        btn_click()
    }, [])
    useEffect(() => {
        if (!data) return;
        setDataTable2(data.table);
    }, [data]);
    const [exportLoading, setExportLoading] = useState(false);
    const [selectedLot, setSelectedLot] = useState();
    const exportFile = async () => {
        setExportLoading(true);
        const res = await exportPQC(params);
        if (res.success) {
            window.location.href = baseURL + res.data;
        }
        setExportLoading(false);
    }

    const [loading, setLoading] = useState(false);
    const [columnDetailError, setColumnDetailError] = useState([
        {
            title: 'Tên lỗi',
            key: 'name',
            dataIndex: 'name',
            align: 'center'
        },
        {
            title: 'Số lượng',
            key: 'value',
            dataIndex: 'value',
            align: 'center'
        }
    ]);
    const [dataDetailError, setDataDetailError] = useState([]);
    const [exportLoading1, setExportLoading1] = useState(false);
    const exportFileDetail = async () => {
        setExportLoading1(true);
        const res = await exportQCHistory(params);
        if (res.success) {
            window.location.href = baseURL + res.data;
        }
        setExportLoading1(false);
    }
    const [isModalBCOpen, setIsModalBCOpen] = useState(false);
    const showModalBC = () => {
        setIsModalBCOpen(true);
    };
    const closeModalBC = () => {
        setIsModalBCOpen(false);
    };
    const [formExportReport] = Form.useForm();
    const [exportLoading2, setExportLoading2] = useState(false);
    const exportReport = async (values) => {
        setExportLoading2(true);
        const res = await exportReportQC(values);
        if (res.success) {
            window.location.href = baseURL + res.data;
        }
        setExportLoading2(false);
    }
    const [exportLoading3, setExportLoading3] = useState(false);
    const exportQCError = async () => {
        setExportLoading3(true);
        const res = await exportQCErorList(params);
        if (res.success) {
            window.location.href = baseURL + res.data;
        }
        setExportLoading3(false);
    }
    const onCheck = (checkedKeys, info) => {
        const selectKeys = [];
        if (info.node.type === 'phan_xuong') {
            if (info.checked) {
                info.node.children.map(e => {
                    selectKeys.push(e.key?.toString())
                })
            }
        } else {
            info.checkedNodes.map(e => {
                switch (e.type) {
                    case 'line':
                        selectKeys.push(e.key?.toString());
                        break;
                    case 'machine':
                        selectKeys.push(e.line_id?.toString());
                        break;
                    default:
                        break;
                }
            })
        }
        setParams({ ...params, line_id: [...new Set(selectKeys)] })
    };
    const [dateType, setDateType] = useState('date');
    const customDateFormat = (value) => {
        switch (dateType) {
            case 'week':
                return (`Tuần ${dayjs(value).format('WW')} - ${dayjs(value).format('YYYY')}`);
                break;
            case 'month':
                return (`Tháng ${dayjs(value).format('MM')} - ${dayjs(value).format('YYYY')}`);
                break;
            default:
                return (dayjs(value).format('DD/MM/YYYY'));
                break;
        }
    }
    useEffect(()=>{
        onChangeDate('start_date', params.date[0], dateType);
        onChangeDate('end_date', params.date[1], dateType);
    }, [dateType])
    const onChangeDate = (position, value, dateType) => {
        switch (dateType) {
            case 'week':
                if (position === 'start_date') {
                    setParams({ ...params, date: [dayjs(value).startOf('isoWeek'), dayjs(params.date[1]).endOf('isoWeek')] });
                } else {
                    setParams({ ...params, date: [dayjs(params.date[0]).startOf('isoWeek'), dayjs(value).endOf('isoWeek')] });
                }
                break;
            case 'month':
                if (position === 'start_date') {
                    setParams({ ...params, date: [dayjs(value).startOf('month'), dayjs(params.date[1]).endOf('month')] })
                } else {
                    setParams({ ...params, date: [dayjs(params.date[0]).startOf('month'), dayjs(value).endOf('month')] });
                }
                break;
            default:
                if (position === 'start_date') {
                    setParams({ ...params, date: [dayjs(value), dayjs(params.date[1])] })
                } else {
                    setParams({ ...params, date: [dayjs(params.date[0]), dayjs(value)] });
                }
                break;
        }
    }
    return (
        <React.Fragment>
            {contextHolder}
            <Row style={{ padding: '8px' }} gutter={[8, 8]} className='custom-row'>
                <Col span={4} className='custom-col'>
                    <Card bodyStyle={{ padding: 0 }} className='custom-ant-card' actions={[
                        <Button type="primary" style={{ width: "90%" }} onClick={() => btn_click()}>Truy vấn</Button>
                    ]}>
                        <Form style={{ margin: '0 8px' }} layout="vertical">
                            <Divider>Công đoạn</Divider>
                            <Form.Item className='mb-3'>
                                {
                                    listLines.length ?
                                        <Tree
                                            defaultExpandedKeys={['xuong_giay']}
                                            style={{ maxHeight: 250, overflowY: 'auto' }}
                                            checkable
                                            onCheck={onCheck}
                                            treeData={listLines}
                                        />
                                        :
                                        <LoadingOutlined />
                                }
                            </Form.Item>
                            <Divider>Thời gian truy vấn</Divider>
                            <Radio.Group
                                options={[
                                    { value: 'date', label: 'Ngày', style: { width: '33%', justifyContent: 'center', display: 'flex' } },
                                    { value: 'week', label: 'Tuần', style: { width: '33%', justifyContent: 'center', display: 'flex' } },
                                    { value: 'month', label: 'Tháng', style: { width: '33%', justifyContent: 'center', display: 'flex' } },
                                ]}
                                className='d-flex justify-content-center mb-2 w-100'
                                onChange={(e) => setDateType(e.target.value)}
                                value={dateType}
                                optionType="button"
                                buttonStyle="solid"
                            />
                            <Space direction='vertical' style={{ width: '100%' }}>
                                <DatePicker allowClear={false} placeholder='Bắt đầu' style={{ width: '100%' }} onChange={(value) => onChangeDate('start_date', value, dateType)} value={params.date[0]} format={customDateFormat} picker={dateType} />
                                <DatePicker allowClear={false} placeholder='Kết thúc' style={{ width: '100%' }} onChange={(value) => onChangeDate('end_date', value, dateType)} value={params.date[1]} format={customDateFormat} picker={dateType} />
                            </Space>
                            <Divider>Điều kiện truy vấn</Divider>
                            <Form.Item label="Khách hàng" className='mb-3'>
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="Chọn khách hàng"
                                    onChange={(value) => { setParams({ ...params, khach_hang: value }); }}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    popupMatchSelectWidth={listCustomers.length ? 400 : "100%"}
                                    options={listCustomers}
                                />
                            </Form.Item>
                            <Form.Item label="Tên sản phẩm" className='mb-3'>
                                <Select
                                    allowClear
                                    showSearch
                                    onChange={(value) => {
                                        setParams({ ...params, ten_sp: value });
                                    }}
                                    placeholder="Nhập tên sản phẩm"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={listNameProducts}
                                />
                            </Form.Item>
                            <Form.Item label="Lô Sản xuất" className='mb-3'>
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="Nhập lô sản xuất"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    onChange={(value) => {
                                        setParams({ ...params, lo_sx: value });
                                    }}
                                    options={listLoSX}
                                />
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>

                <Col span={20} className="custom-col">
                    <Spin spinning={chartLoading}>
                        <Row gutter={[8, 8]}>
                            <Col span={18}>
                                <Card title="Biểu đồ xu hướng lỗi" style={{ height: '100%', padding: '0px' }} bodyStyle={{ padding: 12 }}>
                                    <Line {...configLineChart} />
                                </Card>
                            </Col>
                            <Col span={6}>
                                <Card title="Tỷ lệ lỗi nguyên vật liệu" style={{ height: '100%', padding: '0px' }} bodyStyle={{ padding: 12 }}>
                                    <Pie {...configPieChart3} />
                                </Card>
                            </Col>
                            {/* <Col span={6}>
                            <Card title="Biểu đồ tỉ lệ lỗi" style={{ height: '100%',padding: '0px'}} bodyStyle={{padding:12}}>
                                <Pie {...configPieChart1}/>
                            </Card>
                        </Col> */}
                            <Col span={12}>
                                <Card title="Tỷ lệ lỗi" style={{ height: '100%', padding: '0px' }} bodyStyle={{ padding: 12 }}>
                                    {/* <Pie {...configPieChart2} /> */}
                                    <Column {...configColChart1} />
                                </Card>
                            </Col>
                            <Col span={12}>
                                <Card title="Tần xuất xuất hiện lỗi" style={{ height: '100%', padding: '0px' }} bodyStyle={{ padding: 12 }}>
                                    <Column {...configColChart2} />
                                </Card>
                            </Col>
                            <Col span={24}>

                            </Col>
                        </Row>
                    </Spin>
                    <Card title="Bảng chi tiết lỗi" style={{ padding: '0px' }} bodyStyle={{ padding: 12 }} extra={
                        <Space>
                            <Button type='primary' onClick={showModalBC}>Báo cáo</Button>
                            <Button type='primary' loading={exportLoading1} onClick={exportFileDetail}>Bảng kiểm tra</Button>
                            <Button type='primary' loading={exportLoading} onClick={exportFile}>Xuất excel</Button>
                        </Space>
                    }>
                        <Table
                            bordered
                            loading={loading}
                            size="small"
                            columns={columns2}
                            dataSource={dataTable2}
                            pagination={{
                                current: page,
                                size: 'default',
                                total: totalPage,
                                onChange: (page, pageSize) => {
                                    btn_click(page, pageSize)
                                }
                            }}
                            scroll={
                                {
                                    x: '120vw',
                                    y: '60vh'
                                }
                            } />
                    </Card>
                </Col>

            </Row>

            <Modal title="Chi tiết NG" open={isModalOpen} footer={null} onCancel={closeModal} width={600}>
                <Row gutter={8}>
                    <Col span={12}>
                        <Table bordered size="small" scroll={{ x: '100%' }} columns={columnDetailError} dataSource={dataDetailError} pagination={false}></Table>
                    </Col>
                    <Col span={12}>
                        <Pie {...configPieDetailChart}></Pie>
                    </Col>
                </Row>

            </Modal>
            <Modal title="Báo cáo" open={isModalBCOpen} onCancel={closeModalBC}
                okText="Xuất báo cáo"
                cancelText="Huỷ"
                okButtonProps={{ loading: exportLoading2 }}
                onOk={() => formExportReport.submit()}>
                <Form layout="vertical" form={formExportReport} onFinish={exportReport}
                    initialValues={{
                        day: dayjs(),
                        week: dayjs(),
                        month: dayjs(),
                        year: dayjs(),
                    }}>
                    <Form.Item label={'Ngày'} name={'day'} rules={[{ required: true }]}>
                        <DatePicker style={{ width: '100%' }}></DatePicker>
                    </Form.Item>
                    <Form.Item label={'Tuần'} name={'week'} rules={[{ required: true }]}>
                        <DatePicker picker="week" style={{ width: '100%' }}></DatePicker>
                    </Form.Item>
                    <Form.Item label={'Tháng'} name={'month'} rules={[{ required: true }]}>
                        <DatePicker picker="month" style={{ width: '100%' }}></DatePicker>
                    </Form.Item>
                    <Form.Item label={'Năm'} name={'year'} rules={[{ required: true }]}>
                        <DatePicker picker="year" style={{ width: '100%' }}></DatePicker>
                    </Form.Item>

                </Form>
            </Modal>
        </React.Fragment>
    )
}

export default QualityPQC;
